import { Tooltip } from '@/common/components';
import { styled } from '@/stitches.config';
import { ReactComponent as InfoIcon } from '@assets/icons/info.svg';

const RootContainer = styled('div', {
  display: 'flex',
  alignItems: 'flex-end',
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
      },
      row: {
        flexDirection: 'row',
      },
    },
  },
  defaultVariants: {
    direction: 'row',
  },
});

const TitleContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: '$2',
  alignItems: 'center',
});

const Title = styled('span', {
  fontSize: '$md',
  color: '$darkBlue200',
  lineHeight: '10px',
  gap: '$2',
  marginRight: '$2',
});

const Content = styled('span', {
  fontSize: '$lg',
  color: '$darkBlue200',
  fontWeight: 'bold',
  lineHeight: '$lg',
});

export const InfoIconStyled = styled(InfoIcon, {
  height: '$4',
  width: '$4',
  color: '$darkBlue500',
});

interface TitleInfoProps {
  title: string;
  content: string;
  tooltip?: string;
  direction?: 'column' | 'row';
}

export const TitleInfo = ({ title, content, tooltip, direction }: TitleInfoProps): JSX.Element => {
  return (
    <RootContainer direction={direction}>
      <TitleContainer>
        {tooltip && (
          <Tooltip text={tooltip}>
            <InfoIconStyled />
          </Tooltip>
        )}
        <Title>{title}</Title>
      </TitleContainer>
      <Content>{content}</Content>
    </RootContainer>
  );
};
